/* eslint-disable @typescript-eslint/no-explicit-any */
export const removeEmpty = (obj: Record<string, any>): Record<string, any> =>
  Object.fromEntries(Object.entries(obj).filter((entry) => entry[1] !== ''));
